import { WhereAreWePageFetchedData } from "@/Types/FetchedDataTypes"

export default function slugGenerator(clinicAddress: WhereAreWePageFetchedData) {
  const result = clinicAddress.hospitalName.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(' ', '-').replaceAll('/', '-').replaceAll("ı", "i").replaceAll("İ", "i").replaceAll("I", "i").replaceAll("ğ", "g").replaceAll("Ğ", "G").replaceAll("ü", "u")
    .replaceAll("Ü", "U")
    .replaceAll("ş", "s")
    .replaceAll("Ş", "S")
    .replaceAll("ö", "o")
    .replaceAll("Ö", "O")
    .replaceAll("ç", "c")
    .replaceAll("Ç", "C") + "-" + clinicAddress.doctorName?.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(' ', '-').replaceAll('/', '-').replaceAll("ı", "i").replaceAll("İ", "i").replaceAll("I", "i").replaceAll("ğ", "g").replaceAll("Ğ", "G").replaceAll("ü", "u")
      .replaceAll("Ü", "U")
      .replaceAll("ş", "s")
      .replaceAll("Ş", "S")
      .replaceAll("ö", "o")
      .replaceAll("Ö", "O")
      .replaceAll("ç", "c")
      .replaceAll("Ç", "C") + "-" + clinicAddress.address.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(' ', '-').replaceAll('/', '-').replaceAll("ı", "i").replaceAll("İ", "i").replaceAll("I", "i").replaceAll("İ", "i").replaceAll("ğ", "g").replaceAll("Ğ", "G").replaceAll("ü", "u")
        .replaceAll("Ü", "U")
        .replaceAll("ş", "s")
        .replaceAll("Ş", "S")
        .replaceAll("ö", "o")
        .replaceAll("Ö", "O")
        .replaceAll("ç", "c")
        .replaceAll("Ç", "C")

  return result
}

export function userSearchSlugGenerator(userInput: string) {
  const result = userInput.toLocaleLowerCase().replaceAll(' ', '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll("ı", "i").replaceAll("İ", "i").replaceAll("I", "i").replaceAll("ğ", "g").replaceAll("Ğ", "G").replaceAll("ü", "u")
    .replaceAll("Ü", "U")
    .replaceAll("ş", "s")
    .replaceAll("Ş", "S")
    .replaceAll("ö", "o")
    .replaceAll("Ö", "O")
    .replaceAll("ç", "c")
    .replaceAll("Ç", "C")

  return result
}